<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-row class="mt-1">
            <v-col cols="12" sm="5">
                <h4>{{$t('Nueva categoria')}}</h4>
                <v-card>
                    <v-card-text>
                        <v-form @submit.prevent="registerCat" ref="refAddCat" lazy-validation>
                            <v-text-field
                                :label="$t('Nombre de la categoría')"
                                dense
                                outlined
                                :rules="[rules.required]"
                                v-model="nameCat"
                                :error="(errors['name']) ? true : false"
                                :error-messages="(errors['name']) ? errors['name'][0] : ''"
                            ></v-text-field>
                            <v-select
                                :items="itemsSizes"
                                :label="$t('Tamaño de los banners por categoría')"
                                item-text="label"
                                item-value="val"
                                outlined
                                dense
                                :rules="[rules.required]"
                                v-model="sizeBanner"
                            ></v-select>
                            <div class="mb-4" style="width:150px">
                                <h5>{{$t('Vista previa alto')}}</h5>
                                <v-img
                                    :aspect-ratio="sizeBanner"
                                    class="grey"
                                ></v-img>
                            </div>
                            <div class="text-right">
                                <v-btn color="primary" type="submit" :loading="loading">
                                    {{ $t('Añadir') }}
                                </v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="7">
                <h4>{{$t('Categorias')}}</h4>
                <v-card>
                    <v-card-text>
                        <draggable
                            :list="listCat"
                            :disabled="!enabled"
                            class="list-group"
                            ghost-class="ghost"
                            :move="checkMove"
                            @start="dragging = true"
                            @end="dragging = false"
                        >
                            <div
                                class="list-group-item"
                                v-for="element in listCat"
                                :key="element.id"
                            >
                                <div class="row align-center">
                                    <div class="col-8">
                                        <v-edit-dialog
                                            :ref="'dialogEdit' + element.id"
                                            :return-value.sync="element.name"
                                            @cancel="cancel"
                                            persistent
                                        > {{ element.name }}
                                            <template v-slot:input>
                                            <v-form :ref="'formEdit' + element.id" lazy-validation @keydown.enter.native.stop.prevent="saveEdit(element)" class="py-4">
                                                <v-text-field
                                                    v-model="element.name"
                                                    :label="$t('Editar')"
                                                    single-line
                                                    dense
                                                    :rules="[rules.required]"
                                                ></v-text-field>
                                                <v-select
                                                    :items="itemsSizes"
                                                    :label="$t('Tamaño de los banners por categoría')"
                                                    item-text="label"
                                                    item-value="val"
                                                    single-line
                                                    dense
                                                    v-model="element.size_banner"
                                                    :rules="[rules.required]"
                                                ></v-select>
                                                <!-- status -->
                                                <v-switch
                                                    v-model="element.state"
                                                    inset
                                                    :label="`${$t('Estado')}: ${(element.state)?$t('activo'):$t('inactivo')}`"
                                                ></v-switch>
                                                <!-- end status -->
                                                <!-- subcategorias -->
                                                <v-sheet outlined color="grey lighten-4 pa-3">
                                                    <h5 class="mb-2">{{$t('Subcategorias')}}</h5>
                                                    <div v-for="(child, j) in element.children" :key="j" class="mb-3">
                                                        <v-row>
                                                            <v-col cols="5">
                                                                <v-text-field
                                                                    :label="$t('Nombre de la categoría')"
                                                                    dense
                                                                    outlined
                                                                    :rules="[rules.required]"
                                                                    v-model="child.name"
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col cols="5">
                                                                <v-select
                                                                    :items="itemsSizes"
                                                                    :label="$t('Tamaño de los banners por categoría')"
                                                                    item-text="label"
                                                                    item-value="val"
                                                                    outlined
                                                                    dense
                                                                    :rules="[rules.required]"
                                                                    v-model="child.size_banner"
                                                                ></v-select>
                                                            </v-col>
                                                            <v-col cols="2">
                                                                <v-btn
                                                                    color="error"
                                                                    icon
                                                                    @click="element.children.splice(j, 1)"
                                                                >
                                                                    <v-icon>mdi-delete</v-icon>
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                        <!-- subcategorias de la subcategoria (3er nivel) -->
                                                        <v-sheet outlined color="grey lighten-3 pa-3 ml-4" v-if="categories3Levels">
                                                            <h6 class="mb-2">{{$t('Subcategorias')}} - {{ child.name }}</h6>
                                                            <v-row v-for="(grandchild, g) in child.children" :key="g">
                                                                <v-col cols="5">
                                                                    <v-text-field
                                                                        :label="$t('Nombre de la categoría')"
                                                                        dense
                                                                        outlined
                                                                        :rules="[rules.required]"
                                                                        v-model="grandchild.name"
                                                                    ></v-text-field>
                                                                </v-col>
                                                                <v-col cols="5">
                                                                    <v-select
                                                                        :items="itemsSizes"
                                                                        :label="$t('Tamaño de los banners por categoría')"
                                                                        item-text="label"
                                                                        item-value="val"
                                                                        outlined
                                                                        dense
                                                                        :rules="[rules.required]"
                                                                        v-model="grandchild.size_banner"
                                                                    ></v-select>
                                                                </v-col>
                                                                <v-col cols="2">
                                                                    <v-btn
                                                                        color="error"
                                                                        icon
                                                                        @click="child.children.splice(g, 1)"
                                                                    >
                                                                        <v-icon>mdi-delete</v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                            <div class="text-right">
                                                                <v-btn
                                                                    color="primary"
                                                                    x-small
                                                                    @click="child.children.push({id: '', name: '', size_banner: ''})"
                                                                >{{$t('Añadir')}}</v-btn>
                                                            </div>
                                                        </v-sheet>
                                                        <!-- END subcategorias de la subcategoria -->
                                                    </div>
                                                    <div class="text-right">
                                                        <v-btn
                                                            color="primary"
                                                            small
                                                            @click="element.children.push({id: '', name: '', size_banner: '', children: []})"
                                                        >{{$t('Añadir')}}</v-btn>
                                                    </div>
                                                </v-sheet>
                                                <!-- END subcategorias -->
                                                <div class="text-right mt-3">
                                                    <v-btn
                                                        text
                                                        @click="cancelEdit(element)"
                                                    >{{$t('Cancelar')}}</v-btn>
                                                    <v-btn
                                                        color="primary"
                                                        @click="saveEdit(element)"
                                                    >{{$t('Guardar')}}</v-btn>
                                                </div>
                                            </v-form>
                                            </template>
                                        </v-edit-dialog>
                                    </div>
                                    <div class="col-4 text-right">
                                        <v-chip
                                            small
                                            color="success"
                                            v-if="element.state"
                                        >{{$t('Activo')}}</v-chip>
                                        <v-chip
                                            small
                                            color="error"
                                            v-else
                                        >{{$t('inactivo')}}</v-chip>
                                        <v-btn icon @click="deleteCat(element.id)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </div>
                                </div>
                                <v-divider></v-divider>
                            </div>
                        </draggable>
                    </v-card-text>
                </v-card>
                <div class="text-right mt-5">
                    <v-btn outlined @click="upOrderCat">
                        {{$t('Actualizar Orden')}}
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import draggable from 'vuedraggable'

export default {
    components: {
        draggable,
    },
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    href: '/admin/dashboard',
                },
                {
                    text: 'Mis categorías',
                    disabled: true,
                    href: '',
                }
            ],
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido'
            },
            errors: {},
            nameCat: '',
            itemsSizes: [
                {label: '1:1 Cuadrado', val: +((1/1).toFixed(5))},
                {label: '2:3 Vertical', val: +((2/3).toFixed(5))},
                {label: '3:2 Horizontal', val: +((3/2).toFixed(5))}
            ],
            sizeBanner: '',
            headers: [
                { text: 'Nombre', sortable: false, value: 'name' },
                { text: '', sortable: false, value: 'actions', align: 'end' }
            ],
            listCat: [],
            errors: {},
            // drag
            enabled: true,
            list: [
                { name: "John", id: 0 },
                { name: "Joao", id: 1 },
                { name: "Jean", id: 2 }
            ],
            dragging: false,
            dialogForm: false,
            categories3Levels: false
        }
    },
    created() {
        this.getCategories();
        this.getCategoriesConfig();
    },
    methods: {
        async getCategoriesConfig() {
            await axios.get('/admin/categories-config')
            .then(response => {
                this.categories3Levels = response.data.categories3Levels ? true : false
            })
            .catch(error => {
                // console.log(error);
            })
        },
        async getCategories() {
            await axios.post('/admin/list-categories', {type: 'all'})
            .then(response => {
                // console.log(response);
                this.listCat = response.data
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
        async registerCat () {
            if (this.$refs.refAddCat.validate()) {
                this.errors = {}
                this.loading = true
                await axios.post('/admin/categories', { name: this.nameCat, size: this.sizeBanner })
                .then(response => {
                    // console.log(response);
                    if (response.data === 'ok') {
                        this.$alert('', this.$t('Categoría registrada con éxito.'), 'success', {confirmButtonText: this.$t('Continuar')})
                        // this.nameCat = ''
                        this.$refs.refAddCat.resetValidation()
                        this.$refs.refAddCat.reset()
                        this.getCategories();
                    }

                    this.loading = false
                })
                .catch(error => {
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                    }
                    this.loading = false
                })
            }
        },
        save (id, up, size, state, children) {
            // console.log(up);
            const formData = new FormData
            formData.append('name', up)
            formData.append('size', size)
            formData.append('state', state?1:0)
            formData.append('children', JSON.stringify(children))
            formData.append('_method', 'PUT')
            axios.post(`/admin/categories/${id}`, formData)
            .then(response => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success(this.$t('Categoría actualizada con éxito.'));
                    this.nameCat = ''
                    this.getCategories();
                }
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.getCategories();
            })
        },
        cancel () {
            this.$notify.info(this.$t('Cancelado.'));
        },
        saveEdit (element) {
            const form = this.getEditRef('formEdit' + element.id)
            if (form && !form.validate()) {
                this.$notify.error(this.$t('Complete los campos obligatorios'))
                return
            }
            this.save(element.id, element.name, element.size_banner, element.state, element.children)
            this.closeEditDialog(element)
        },
        cancelEdit (element) {
            this.cancel()
            this.closeEditDialog(element)
        },
        closeEditDialog (element) {
            const dialog = this.getEditRef('dialogEdit' + element.id)
            if (dialog) dialog.isActive = false
        },
        // refs dentro de v-for siempre son array en Vue 2, aunque la key sea dinámica y única
        getEditRef (key) {
            const ref = this.$refs[key]
            return Array.isArray(ref) ? ref[0] : ref
        },
        async deleteCat (id) {
            if (confirm(this.$t('Eliminar categoría. ¿Desea continuar?'))) {
                await axios.delete(`/admin/categories/${id}`)
                .then(response => {
                    // console.log(response);
                    if (response.data === 'ok') {
                        this.$notify.success(this.$t('Categoría eliminada con éxito.'));
                        this.getCategories();
                    }
                })
                .catch(error => {
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error, es posible que tenga productos registrados con esta categoría.'));
                    }
                })
            }
        },
        // order
        checkMove: function(e) {
            window.console.log("Future index: " + e.draggedContext.futureIndex);
        },
        upOrderCat () {
            const formData = new FormData()
            for (let index = 0; index < this.listCat.length; index++) {
                formData.append(`order[]`, this.listCat[index].id)
            }
            axios.post(`/admin/update-order-cat`, formData)
            .then(response => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success(this.$t('El orden de las categorías fue actualizado con éxito.'));
                    this.getCategories();
                }
            })
            .catch(error => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        }
    },
}
</script>
<style lang="scss">
    .list-group-item {
        cursor: pointer;
    }
</style>
